import { fromJS, Record } from 'immutable';
import { generateKeys, generateSchema } from '../../helpers/model.helper';
import { ITrackingAction, TrackingActionNamesEnum } from '../tracking.data';

export const TRACKING_CHART_TAPPED_SCHEMA = Object.freeze({
  CHART_IDENTIFIER: '',
  SCREEN_NAME: '',
});
const RECORD = generateSchema(TRACKING_CHART_TAPPED_SCHEMA);
const KEYS: any = generateKeys(TRACKING_CHART_TAPPED_SCHEMA);

export class ChartTappedTrackingAction
  extends Record(RECORD)
  implements ITrackingAction {
  static KEYS = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get name() {
    return TrackingActionNamesEnum.chart_tapped;
  }

  get properties() {
    return this.toJS();
  }
}
